import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memberSearch", "memberSelect", "userSearch", "userSelect","personSearch", "personSelect"]

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  filterMembers() {
    this.selectFirstMatch(this.memberSelectTarget, this.memberSearchTarget.value)
  }

  filterUsers() {
    this.selectFirstMatch(this.userSelectTarget, this.userSearchTarget.value)
  }

  filterPeople() {
     console.log("filterPeople", this.personSearchTarget.value, this.personSelectTarget)
    this.selectFirstMatch(this.personSelectTarget, this.personSearchTarget.value)
}


  memberChanged() {
  if (this.memberSelectTarget.value) {
    this.userSelectTarget.value = ""
    this.userSearchTarget.value = ""
    this.personSelectTarget.value = ""
    this.personSearchTarget.value = ""
  }
}

  userChanged() {
    if (this.userSelectTarget.value) {
      this.memberSelectTarget.value = ""
      this.memberSearchTarget.value = ""
      this.personSelectTarget.value = ""
      this.personSearchTarget.value = ""
    }
  }

  personChanged() {
    if (this.personSelectTarget.value) {
      this.memberSelectTarget.value = ""
      this.memberSearchTarget.value = ""
      this.userSelectTarget.value = ""
      this.userSearchTarget.value = ""
    }
  }

  selectFirstMatch(select, query) {
    const q = query.trim().toLowerCase()

    if (q.length === 0) {
      select.selectedIndex = 0
      return
    }

    const options = Array.from(select.options).slice(1) // skip prompt option
    const match = options.find(option =>
      option.text.toLowerCase().includes(q)
    )

    if (match) {
      select.value = match.value
    } else {
      select.selectedIndex = 0
    }
  }
}